// Imports
import styled from 'styled-components/macro';


// Styled component
const Wrapper = styled.iframe`
	display: flex;
	line-height: 1.3125rem;
	
	border: none;
	height: 31.25rem;
	width: 100%;
	
	@media only screen and (max-width: 48rem) {
		height: 18.75rem;
	}
`;


// Define the accepted props
interface Props {
	pageID: number;
}


// Function component
const Location: React.FC<Props> = ({ pageID }) => {
	// Retrieve access token cookie
	const accessTokenCookie = document.cookie.match(/(^|;)\s*access-token\s*=\s*([^;]+)/)?.[2] ?? null;
	const accessToken = accessTokenCookie ? `?access-token=${encodeURIComponent(accessTokenCookie)}` : '';
	
	
	// Return JSX
	return (
		<Wrapper
			src={`https://embedded-map.api.${process.env.REACT_APP__ENVIRONMENT_HOSTNAME}/page/${pageID}/type/205${accessToken}`}
			allowFullScreen
			title='Map'
		></Wrapper>
	);
};

export default Location;
